import { Component, OnDestroy, OnInit } from '@angular/core';
import { CommonService } from '../../../services/common';
import { SalesService } from '../sales.service';
import { ActivatedRoute, Router } from '@angular/router';
import { Subject, takeUntil } from 'rxjs';

@Component({
  selector: 'app-booking',
  templateUrl: './booking.component.html',
  styleUrl: './booking.component.scss',
})
export class BookingComponent implements OnInit, OnDestroy {

  showaddUpdateModal: boolean = false;
  showDocumentModal: boolean = false;
  recordList: any;
  //used to send current record to booking document modal
  selectedRecord: any;
  bookingSupportData: any;
  isChildCall: boolean = false;
  initials: any;
  UnitCategory: any[] = [];
  paymentPlans: any[] = [];
  cancelledBookings: any[] = []
  agentNames: any;
  customerList: any[] = [];
  projectId!: any;
  bookingId: any
  corelationId: any
  context: string = '';
  private destroy$ = new Subject<void>();

  constructor(public commonService: CommonService, public salesService: SalesService, private route: ActivatedRoute, public router: Router) { }

  ngOnInit() {

    this.bookingId = this.route.snapshot.paramMap.get("bookingId");
    this.corelationId = this.route.snapshot.paramMap.get("paymentId");


    //Get all basics upporting records like initials, customer list, agent list etc.
    if (this.corelationId == null) {
      this.getSelectedProject(true);
    } else {
      // check if view is visited for a specific booking id then fetch data or that particular booking id
      this.RefreshBasicEntityLists()
      this.getBookingListByPaymentId();
      this.recordList = [];
    }
  }
  getBookingListByPaymentId() {
    this.salesService.getFilterBookings(this.projectId, null, null, this.bookingId, this.corelationId).subscribe((res: any) => {
      this.recordList = res?.result?.map((data: any) => {
        let formattedAmount: string = data?.amount?.toLocaleString('en-IN');
        data.amount = formattedAmount;
        data.originalAmount = formattedAmount?.replaceAll(',', '');
        let sourceNameinitial: any = this.initials?.find(
          (initial: any) => initial?.id == data?.sourceDetail?.nameInitialsId
        );
        if (data.clientDetail) {
          data.clientName = data?.clientDetail?.nameInitialsName + '.' + data?.clientDetail?.firstName + ' ' + data?.clientDetail?.lastName;
        }
        data.contactNumber = data?.clientDetail?.primaryPhoneNo?.replace(/(\d{5})(\d{5})/, '$1-$2');
        if (data.sourceDetail) {

          data.sourceName =
            (sourceNameinitial ? sourceNameinitial?.name + '. ' : '') +
            data?.sourceDetail?.firstName +
            ' ' +
            data?.sourceDetail?.lastName;
        }
        if (data?.unitCategoryDetail) {
          data.product = data?.unitCategoryDetail?.name;
        }
        return data;
      });
      this.bookingId = this.route.snapshot.paramMap.get("bookingId");

      if (this.bookingId != null && this.bookingId != "undefined") {

        let filterPlanObject = {
          showaddUpdateModal: true,
          currentSelectedRecord: this.recordList?.find((x: any) => x.id == parseInt(this.bookingId)),
          isSubmitted: false
        }
        this.changeAddUpdateModelState(filterPlanObject);
      }
    })
  }
  /**
   * Select the current project
   */
  getSelectedProject(isrefresh = false) {
    this.commonService.selectedProjects$
      .pipe(takeUntil(this.destroy$)).subscribe((selectedProject: any) => {
        this.recordList = [];
        if (selectedProject != null) {
          if (isrefresh) {
            this.RefreshBasicEntityLists();
          }
          this.projectId = selectedProject?.id;
          this.salesService.getFilterBookings(this.projectId, null, null, this.bookingId).subscribe((res: any) => {
            if (res != null) {
              this.recordList = res?.result?.map((data: any) => {
                let formattedAmount: string = data?.amount?.toLocaleString('en-IN');
                data.amount = formattedAmount;
                data.originalAmount = formattedAmount?.replaceAll(',', '');
                let formattedReceivedAmount = data?.recivedAmount?.toLocaleString('en-IN');
                data.recivedAmount = formattedReceivedAmount;
                let sourceNameinitial: any = this.initials?.find(
                  (initial: any) => initial?.id == data?.sourceDetail?.nameInitialsId
                );
                if (data.clientDetail) {
                  data.clientName = data?.clientDetail?.nameInitialsName + '.' + ' ' + data?.clientDetail?.firstName + ' ' + data?.clientDetail?.lastName;
                }
                data.contactNumber = data?.clientDetail?.primaryPhoneNo?.replace(/(\d{5})(\d{5})/, '$1-$2');
                if (data.sourceDetail) {

                  data.sourceName =
                    (sourceNameinitial ? sourceNameinitial?.name + '. ' : '') +
                    data?.sourceDetail?.firstName +
                    ' ' +
                    data?.sourceDetail?.lastName;
                }
                if (data?.unitCategoryDetail) {
                  data.product = data?.unitCategoryDetail?.name;
                }

                return data;
              });
              this.bookingId = this.route.snapshot.paramMap.get("bookingId");

              if (this.bookingId != null && this.bookingId != "undefined") {

                let filterPlanObject = {
                  showaddUpdateModal: true,
                  currentSelectedRecord: this.recordList?.find((x: any) => x.id == parseInt(this.bookingId)),
                  isSubmitted: false
                }
                this.changeAddUpdateModelState(filterPlanObject);
              }
            }
          })
        }
      });
  }

  /**
   * Get name initials for a customer name
   */
  getInitials() {
    this.salesService.getInitials().then((res: any) => {
      if (res) {
        this.initials = res?.result;
      }
    });
  }

  // get unit-category data
  getUnitCategory() {
    const selectedProject: any = JSON.parse(this.commonService.getValueFromLocalStorage("selectedProject")!);
    if (selectedProject) {
      this.salesService.getUnitCategory().subscribe((res: any) => {
        this.UnitCategory = res?.result;
      });
    } else {
      this.UnitCategory = [];
    }
  }

  // get agent names
  getAgentNames() {
    this.salesService.getAgents().then((res: any) => {
      if (res?.result) {
        this.agentNames = res?.result.map((i: any) => {
          i.fullName =
            i?.nameInitial?.name + '. ' + i?.firstName + ' ' + i?.lastName;
          return i;
        });
      }
    });
  }

  // get payment plan data
  getPaymentPlan() {
    this.salesService.getpaymentPlan().subscribe((res: any) => {
      this.paymentPlans = res?.result;
    });
  }

  // get payment plan data
  getCancelledBookingsWithoutPreviousBooking() {
    this.salesService.getFilterBookings(this.projectId, null, null, null, null, null, true, null, true).subscribe((res: any) => {
      this.cancelledBookings = res?.result.map((booking: any) => {
        return {
          id: booking?.id,
          bookingDate: booking.bookingDate,
          clientName: booking?.clientDetail?.nameInitialsName + ' ' + booking?.clientDetail?.firstName + ' ' + booking?.clientDetail?.lastName,
          product: booking?.unitCategoryDetail?.name
        }
      });
    });
  }

  RefreshBasicEntityLists() {
    //Refresh Name Initials
    this.getInitials()

    //refresh Unit-Category
    this.getUnitCategory()

    //Refresh Agent List
    this.getAgentNames()

    //Refresh Payment Plan
    this.getPaymentPlan()

    //Refresh Cancelled Bookings without previous booking
    this.getCancelledBookingsWithoutPreviousBooking()
  }

  changeDocumentModalState(displayModal: boolean = false, currentRecord?: any) {
    this.showDocumentModal = displayModal
    this.selectedRecord = currentRecord?.currentSelectedRecord
  }


  changeAddUpdateModelState(modalStatus: any) {
    //set this object only if we are opening the form not closing this
    if (modalStatus?.showaddUpdateModal) {
      this.bookingSupportData = {
        "currentRecord": modalStatus?.currentSelectedRecord,
        "nameInitialsList": this.initials,
        "paymentPlansList": this.paymentPlans,
        "unitcategoryList": this.UnitCategory,
        "agentList": this.agentNames,
        "cancelledBookingList": this.cancelledBookings
      }
    }

    if (modalStatus?.context) {
      this.context = modalStatus?.context;
    } else {
      this.context = "Add"
    }


    this.showaddUpdateModal = modalStatus?.showaddUpdateModal;
    this.showDocumentModal = modalStatus?.showDocumentModal;

    //If record was submitted (added/updated) then refresh the booking list only.
    //other wise refresh enitire page.
    if (modalStatus?.isSubmitted) {
      //When user come from edit record by id using URLthen reset url when submit the form.
      if (this.bookingId != null && this.bookingId != "undefined") {
        this.router.navigate(['sales/booking']);
      } else {
        this.getSelectedProject(false);
        //since now any cancelled booking can be atatched with a fresh booking hence need to refresh cancelled booking also
        //so that on next modal open (add update) only those cancelled  booking appear in list which againsh which no fresh 
        // booking created yet 
        this.getCancelledBookingsWithoutPreviousBooking()
      }
    }
    //When cancel the booking then for refresh the data this condition is applicable
    if (modalStatus?.isCancelled) {
      this.getSelectedProject(false);
    }
  }

  closePaymentDialogue() {
  }

  ngOnDestroy(): void {
    // Signal completion to clean up subscriptions
    this.destroy$.next();
    this.destroy$.complete();
  }
}
